export default __webpack_public_path__ + "static/media/eos-one-logo.ee905868.svg";